var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../services/http.service";
import { accountTransactionTypes, env } from "../../constants/global.constants";
import "react-datepicker/dist/react-datepicker.css";
import { dateTimeFormat, loadingAnimation, ServerDate } from "../../services/misc.functions";
import _ from "lodash";
import { useNavigate, useParams } from "react-router";
import { registerLocale } from "react-datepicker";
import { tr } from "date-fns/locale/tr";
registerLocale("tr", tr);
export function AccountTransactions() {
    var _this = this;
    var today = ServerDate();
    var params = useParams();
    var _a = useState([]), dataList = _a[0], setDataList = _a[1];
    var _b = useState(0), page = _b[0], setPage = _b[1];
    var _c = useState({
        start_date: today.toISOString().slice(0, 10),
        end_date: null,
        trans_type: null,
    }), filter = _c[0], setFilter = _c[1];
    var _d = useState(new Date()), startDate = _d[0], setStartDate = _d[1];
    var _e = useState(new Date()), endDate = _e[0], setEndDate = _e[1];
    var navigate = useNavigate();
    useEffect(function () {
        loadData();
    }, [filter]);
    var loadData = function (force) {
        if (force === void 0) { force = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingAnimation(true);
                        if (page === 0 || force === 0) {
                            setDataList([]);
                        }
                        payload = {
                            metadata: {
                                page: force ? force : page,
                            },
                            // start_date: startDate ? startDate.toISOString().slice(0, 10) : '',
                            // end_date: endDate ? endDate.toISOString().slice(0, 10) : '',
                            start_date: filter.start_date,
                            end_date: filter.end_date,
                            trans_type: filter.trans_type,
                        };
                        return [4 /*yield*/, api
                                .start("post", env.accounting_api + "/member/api/list-transaction/", payload, true)
                                .then(function (res) {
                                // console.log(res);
                                loadingAnimation(false);
                                setPage(page + 1);
                                if (res && res.status) {
                                    dataList.push.apply(dataList, res.data);
                                    setDataList(dataList);
                                }
                                if (res && res.metadata) {
                                    var id_datalist_loadmore = document.getElementById("id_datalist_loadmore");
                                    if (res.metadata.total_page <= page + 1) {
                                        id_datalist_loadmore.style.display = "none";
                                    }
                                    else {
                                        id_datalist_loadmore.style.display = "block";
                                    }
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // fixme load more için bulk testler yapılmalı şu an kayıt az olduğu için test yapamıyorum.
    var loadMore = function (e) {
        e.target.disabled = true;
        loadData().finally(function () {
            e.target.disabled = false;
        });
    };
    var _f = useForm(), register = _f.register, handleSubmit = _f.handleSubmit, reset = _f.reset, errors = _f.formState.errors;
    var onSubmit = function (data) {
        var startDate = new Date(today);
        startDate.setDate(startDate.getDate() - Number(data.date));
        setPage(0);
        setDataList([]);
        var _filter = {
            start_date: startDate.toISOString().slice(0, 10) + "T00:00:00",
            trans_type: data.trans_type !== "-1" ? data.trans_type : null,
        };
        if (Number(data.date) == 0 || Number(data.date) == 1) {
            _filter.end_date = startDate.toISOString().slice(0, 10) + "T23:59:59";
        }
        // console.log(_filter);
        setFilter(_filter);
    };
    var onChange = function (dates) {
        var start = dates[0], end = dates[1];
        setStartDate(start);
        setEndDate(end);
        if (start != null && end != null) {
            var payload = {
                metadata: {
                    page: 0,
                },
                start_date: start ? start.toISOString().slice(0, 10) : "",
                end_date: end ? end.toISOString().slice(0, 10) : "",
                trans_type: filter.trans_type,
            };
            api.start("post", env.accounting_api + "/member/api/list-transaction/", payload, true).then(function (res) {
                loadingAnimation(false);
                setPage(page + 1);
                if (res && res.status) {
                    setDataList(res.data);
                }
                if (res && res.metadata) {
                    var id_datalist_loadmore = document.getElementById("id_datalist_loadmore");
                    if (res.metadata.total_page <= page + 1) {
                        id_datalist_loadmore.style.display = "none";
                    }
                    else {
                        id_datalist_loadmore.style.display = "block";
                    }
                }
            });
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-3 col-mobile-12 my-sm-2" }, { children: _jsxs("div", __assign({ className: "card rounded-4" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: "Filtrele" }) })), _jsx("div", __assign({ className: "card-body" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx("div", __assign({ className: "row mb-2" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("select", __assign({ className: "form-control" }, register("date"), { children: [_jsx("option", __assign({ value: 7 }, { children: "Son 1 Hafta" })), _jsx("option", __assign({ value: 0, selected: true }, { children: "Bug\u00FCn" })), _jsx("option", __assign({ value: 1 }, { children: "D\u00FCn" })), _jsx("option", __assign({ value: 30 }, { children: "Son 30 G\u00FCn" })), _jsx("option", __assign({ value: 90 }, { children: "Son 3 Ay" })), _jsx("option", __assign({ value: 180 }, { children: "Son 6 Ay" })), _jsx("option", __assign({ value: 365 }, { children: "Son 1 Sene" })), _jsx("option", __assign({ value: 9999 }, { children: "T\u00FCm Zamanlar" }))] })) })) })), _jsx("div", __assign({ className: "row mb-2" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("select", __assign({ className: "form-control" }, register("trans_type"), { children: accountTransactionTypes.map(function (type, key) {
                                                        return (_jsx("option", __assign({ value: type.id }, { children: type.name }), "account-transaction-type-".concat(key, "-").concat(type.id)));
                                                    }) })) })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("button", __assign({ className: "btn w-100 btn-primary" }, { children: "G\u00F6ster" })) })) }))] })) }))] })) })), _jsx("div", __assign({ className: "col-9 col-mobile-12" }, { children: _jsxs("div", __assign({ className: "card rounded-4 mb-4" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: "Hesap Hareketleri" }) })), _jsxs("div", __assign({ className: "card-body" }, { children: [dataList && dataList.length > 0 && (_jsxs("table", __assign({ className: "table table-striped table-hover" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Tarih" }), _jsx("th", { children: "\u0130\u015Flem T\u00FCr\u00FC - A\u00E7\u0131klama" }), _jsx("th", __assign({ className: "text-center" }, { children: "Tutar" }))] }) }), _jsx("tbody", { children: _.orderBy(dataList, ["id"], ["desc"]).map(function (item, key) {
                                                    return (_jsxs("tr", { children: [_jsx("td", __assign({ style: { whiteSpace: "normal" } }, { children: dateTimeFormat(item.transaction_date).replace(" ", "\n") })), _jsxs("td", __assign({ style: { whiteSpace: "normal" } }, { children: [item.trans_type_display, " ", (item.trans_type === 7 || item.trans_type === 8) && item.coupon_approve_code ? "- #".concat(item.coupon_approve_code) : '', item.description !== null && _jsx("br", {}), _jsx("span", __assign({ className: "fs-7" }, { children: item.description ? item.description : "" })), _jsx("br", {}), _jsx("span", __assign({ className: "fs-7" }, { children: item.draw_name }))] })), _jsx("td", __assign({ className: "fw-bold text-end" }, { children: _jsxs("span", __assign({ className: "".concat(item.io_type === 0 ? "text-danger" : "text-success") }, { children: [item.amount, " ", item.unit === 1 ? "ŞP" : "TL", item.discount_amount > 0 && (_jsxs(_Fragment, { children: [_jsx("br", {}), item.discount_amount, " TL Kupon bedeli"] }))] })) }))] }, "support-ticket-list-".concat(key)));
                                                }) })] }))), dataList && dataList.length === 0 && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "text-center py-5" }, { children: "Listelenecek hi\u00E7 kay\u0131t yok." })) })), _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("div", { id: "id_loaderAnimation", className: "loader" }), _jsx("button", __assign({ id: "id_datalist_loadmore", onClick: loadMore, type: "button", className: "btn rounded-pill btn-outline-primary" }, { children: "Devam\u0131n\u0131 Y\u00FCkle" }))] }))] }))] })) }))] })) }));
}
